<table class="table-primary">
  <thead>
  <tr>
    <th class="text-left wholesaler" scope="col">
      Wholesaler
    </th>
    <th class="text-left last-processed" scope="col">
      Last Processed
    </th>
    <th class="text-left status" scope="col">
      Status
    </th>
    <th class="text-right controls" scope="col">
      <!-- Controls -->
    </th>
  </tr>
  </thead>
  <tbody>
  <tr [class.invalid]="rowData.status === WholesalerIntegrationStatusEnum.Invalid"
      class="table-row"
      *ngFor="let rowData of wholesalerIntegrationList"
  >
    <td class="text-left wholesaler" scope="row">
      <img class="status-icon"
           *ngIf="rowData.status === WholesalerIntegrationStatusEnum.Created"
           src="assets/icons/icon-wifi-blue.svg"
           alt="working"
      />
      <img class="status-icon"
           popper="Error with wholesaler connection"
           [popperTrigger]="'hover'"
           popperApplyClass="error-message-tooltip"
           popperApplyArrowClass="error-message-arrow"
           *ngIf="rowData.status === WholesalerIntegrationStatusEnum.Invalid"
           src="assets/icons/icon-danger-red.svg"
           alt="error"
      />
      {{rowData.wholesalerName}}
    </td>
    <td class="text-left last-processed" scope="row">
      {{rowData.lastProcessed | formattedDate: 'MM d a, HH:mm'}}
    </td>
    <td class="text-left activity">
      <app-badge *ngIf="rowData.isActive"
                 [color]="BadgeColorsEnum.Green">
        Active
      </app-badge>
      <app-badge *ngIf="!rowData.isActive"
                 [color]="BadgeColorsEnum.Default">
        Inactive
      </app-badge>
    </td>
    <td class="text-right controls">
      <button class="table-menu-btn"
              appMenu
              [placement]="'bottom-right'"
              [autoClose]="'outside'"
              [menuContent]="tableRowMenuContent"
              triggers="manual"
              #tableRowMenu="appMenu"
              (click)="tableRowMenu.toggle();$event.stopPropagation();"
      >
        <img class="menu-icon opened" *ngIf="tableRowMenu.isOpen()" src="assets/icons/icon-close-dark-gray.svg" alt="table-row-menu"/>
        <img class="menu-icon" *ngIf="!tableRowMenu.isOpen()" src="assets/icons/icon-three-dots.svg" alt="table-row-menu"/>
      </button>
      <ng-template #tableRowMenuContent>
        <div class="menu-container primary">
          <div *ngIf="rowData.isActive"
               (click)="runWholesalerIntegration(rowData);tableRowMenu.close();"
               class="menu-item"
          >
            <div class="option run-now">
              Run now
            </div>
          </div>
          <div *ngIf="rowData.isActive"
               (click)="setActivityStatus(rowData, false);tableRowMenu.close();"
               class="menu-item"
          >
            <div class="option start">
              Make Inactive
            </div>
          </div>
          <div *ngIf="!rowData.isActive"
               (click)="setActivityStatus(rowData, true);tableRowMenu.close();"
               class="menu-item"
          >
            <div class="option start">
              Make Active
            </div>
          </div>
          <div (click)="editWholesaler.emit(rowData);tableRowMenu.close();" class="menu-item">
            <div class="option edit">
              Edit
            </div>
          </div>
          <div (click)="openRemoveWholesalerDialog(rowData);tableRowMenu.close();" class="menu-item">
            <div class="option delete">
              Delete
            </div>
          </div>
        </div>
      </ng-template>
    </td>
  </tr>
  </tbody>
</table>

<!-- CLOSE ACCOUNT DIALOG -->
<app-warning-dialog [show]="showRemoveWholesalerDialog"
                    header="Are you sure you want to do this?"
                    description="Deleted wholesalers can be added back later."
                    acceptBtnText="Yes, delete wholesaler"
                    (cancel)="closeRemoveWholesalerDialog()"
                    (next)="removeWholesaler()"
></app-warning-dialog>
